import { Checkbox, FormControlLabel, createTheme } from "@mui/material";
import React from "react";
import { checkBoxStyle } from "assets/jss/jss";
import classNames from "classnames";
import { ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { GridItem } from "..";
import PropTypes from "prop-types";

const useStyles = makeStyles(checkBoxStyle);

const CheckBox = props => {
  const classes = useStyles();
  const {
    label,
    checked,
    name,
    color,
    error,
    success,
    blanco,
    onChange,
    sm,
    md,
    labelPlacement,
    disabled
  } = props;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error,
    [" " + classes.labelRootBlanco]: blanco && !success && !error
  });
  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <ThemeProvider theme={theme}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={disabled}
              checked={checked}
              onChange={onChange}
              name={name}
              color={color}
              className={labelClasses}
            />
          }
          labelPlacement={labelPlacement || "start"}
          label={label}
          className={classes.labelRoot + labelClasses}
        />
      </ThemeProvider>
    </GridItem>
  );
};

export default CheckBox;

CheckBox.propTypes = {
  open: PropTypes.bool,
  label: PropTypes.string,
  checked: PropTypes.bool,
  name: PropTypes.string,
  color: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  blanco: PropTypes.bool,
  onChange: PropTypes.func,
  sm: PropTypes.number,
  md: PropTypes.number,
  labelPlacement: PropTypes.string,
  disabled: PropTypes.bool
};

export const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: "small !important",
          marginRight: "10px"
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: "0"
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          padding: "0px !important"
        },
        label: {
          fontSize: "0.850rem"
        }
      }
    }
  }
});
